import styled, { css } from 'styled-components';

import Icon from 'Elements/Icon';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        padding: 1rem;
        border-radius: 0.5rem;
        background: ${theme.colors.background.hex};

        @media ${theme.breakpoints.large.media} {
            padding: 1rem 1.5rem 1.5rem;
        }
    `}
`;

export const Heading = styled.h3`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-size: 1.75rem;
        font-weight: 300;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.5rem;
        }
    `}
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        font-size: 0.85rem;
        display: flex;
        margin: 1.25rem 0;

        &:last-of-type {
            margin-bottom: 0;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const Label = styled.span`
    ${({ theme }) => css`
        font-size: 1.125rem;
        font-weight: 300;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const StyledIcon = styled(Icon)<{ $colour?: string }>`
    ${({ theme, $colour = theme.colors.accents[7].hex }) => css`
        width: 1.5em;
        min-width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.5rem;
        padding: 0.15rem;
        color: ${$colour};
        border: 0.1rem solid ${$colour};
        border-radius: 50%;
        stroke-width: 0.1rem;

        @media ${theme.breakpoints.large.media} {
            width: 2rem;
            min-width: 2rem;
            height: 2rem;
            margin-right: 0.75rem;
            padding: 0.35rem;
        }
    `}
`;
